
const state = {
  audience_id: undefined,
  audience_type: '',
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
